// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"8f535ce8","226":"13bd7c6d","242":"f3d4cc7c","354":"4cf09e1b","448":"c0651439","574":"4390e44e","878":"eed270f7","965":"fa4be39f"}[chunkId] + ".css";
};